import React, { SVGProps } from 'react';

const SvgNameTransferColorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <rect width={18.592} height={22.723} x={4.266} y={4.94} fill="#EBEBEB" rx={2.066} />
    <path
      stroke="#909090"
      strokeLinecap="round"
      strokeWidth={1.859}
      d="M8.395 11.137h10.328M8.395 15.269h7.23M8.395 19.4h4.131"
    />
    <path
      fill="#6B6B6B"
      d="m24.922 9.072 1.55-3.616 1.548 3.616V26.63c0 .57-.462 1.032-1.032 1.032h-1.033c-.57 0-1.033-.462-1.033-1.032V9.07Z"
    />
  </svg>
);
SvgNameTransferColorIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgNameTransferColorIcon;
